"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dropdown_component_1 = __importDefault(require("../dropdown/dropdown.component"));
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
var pagination_styles_1 = require("./pagination.styles");
var Pagination = function (_a) {
    var _b = _a.currentPage, currentPage = _b === void 0 ? 1 : _b, noOfRows = _a.noOfRows, _c = _a.rowsPerPage, rowsPerPage = _c === void 0 ? 25 : _c, _d = _a.rowsPerPageOptions, rowsPerPageOptions = _d === void 0 ? [25, 50, 100] : _d, onChange = _a.onChange;
    var getTranslation = use_translations_hook_1.default().getTranslation;
    var dropdownOptions = rowsPerPageOptions.map(function (o) { return ({ label: o.toString(), value: o }); });
    var handlePageChange = function (e, pageNumber, noOfRows) {
        e.preventDefault();
        handleChange(pageNumber, noOfRows);
    };
    var handleRowsPerPageChange = function (value) {
        handleChange(currentPage, value);
    };
    var handleChange = function (pageNumber, rowsPerPage) {
        var pageCount = Math.ceil(noOfRows / rowsPerPage);
        var currentPage = pageNumber <= pageCount ? pageNumber : pageCount;
        onChange(currentPage, rowsPerPage);
    };
    var noOfPages = Math.ceil(noOfRows / rowsPerPage);
    return (react_1.default.createElement(pagination_styles_1.PaginationContainer, null,
        getTranslation('PAGINATION:NO_OF_ROWS'),
        react_1.default.createElement(dropdown_component_1.default, { testID: "rows-per-page", embedded: true, options: dropdownOptions, value: rowsPerPage, onChange: handleRowsPerPageChange }),
        ' ',
        react_1.default.createElement(pagination_styles_1.PreviousLink, { visible: currentPage > 1, "data-test-id": "previous-page", href: "#", onClick: function (e) { return handlePageChange(e, currentPage - 1, rowsPerPage); } }, "<"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { "data-test-id": "current-page" }, currentPage),
            " ",
            getTranslation('PAGINATION:OF'),
            ' ',
            react_1.default.createElement("span", { "data-test-id": "no-of-pages" }, noOfPages)),
        react_1.default.createElement(pagination_styles_1.NextLink, { visible: currentPage < noOfPages, "data-test-id": "next-page", href: "#", onClick: function (e) { return handlePageChange(e, currentPage + 1, rowsPerPage); } }, ">")));
};
Pagination.displayName = 'Pagination';
exports.default = Pagination;
